export function isAndroid() {
  try {
    const navigator = window.navigator
    const userAgent = navigator.userAgent
    const normalizedUserAgent = userAgent.toLowerCase()
    return /android/.test(normalizedUserAgent)
  } catch (e) {
    console.error(e)
    return false
  }
}

export function isMobileSafari() {
  try {
    const navigator = window.navigator
    const userAgent = navigator.userAgent

    return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  } catch (e) {
    console.error(e)
    return false
  }
}
